import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

function _window(): any {
  // return the native window obj
  return window;
}

@Injectable()
export class WindowRef {

  constructor(public http: HttpClient) {

  }

  public getnativeWindow(): any {
    return _window();
  }




  // public obtenerDominio(idioma, dominio) {

  //   let cuerpo = {
  //     lenguaje: idioma,
  //     dominio: dominio
  //   };
  //   let header = {
  //     "Content-Type": "application/json"
  //   };

  //   let response = this.http.post("url/dominio", cuerpo, { headers: header })
  //     .map((res: Response) => {
  //       response = <any>res;
  //     })
  //     .catch(e => {

  //       let errorCode = 400;
  //       let statusText = 'Fallo en Consultar dominio';
  //       let error = "Fallo en Consultar dominio" + " " + JSON.stringify(e);

  //     });
  //   return response;
  // }
}

